export default __webpack_public_path__ + "static/media/computer.f53ae7d0.svg";